import React from "react";
import { locales } from "../../locales";
import Percentage from "./Percentage";
import CoalitionBuilder from "./CoalitionBuilder";
import {
  deigrengCase,
  formatDate,
  formatString,
  getSeatNumber,
} from "../../utils/communesUtils";
import DifferencePyramid from "./DifferencePyramid";

const colors = {
  deigreng: "#39B54A",
  lsap: "#F00035",
  csv: "#FFCC00",
  dp: "#002C4F",
  arleit: "#FF6600",
  deilenk: "#e10736",
  kpl: "#FF0000",
  ebl: "#0FA6A6",
  adr: "#b8def1",
  biergerlest: "#653796",
  schetterbierger: "#653796",
  arequipe: "#8A365D",
  piraten: "#a62a8c",
  piratepartei: "#a62a8c",
  schetter: "#662e88",
  biergerlestgemengcliarref: "#eaca87",
  mirdvollek: "#016fb8",
  fraileschtarleitfirrouspertmompech: "#ff6600",
};

const Result = ({ data, langId, isDesktop, currentElected, meta }) => {
  const rawChartDataCurrent = data["2023"].results.resultats.listes;
  const rawChartDataOld = data["2017"].results.resultats.listes;
  let seatsDifference;

  const hasSeatsDifference =
    rawChartDataCurrent?.length > 0 && rawChartDataOld?.length > 0;

  if (hasSeatsDifference) {
    const seatsOld = getSeatNumber(rawChartDataOld);
    const seatsCurrent = getSeatNumber(rawChartDataCurrent);

    seatsDifference = seatsCurrent.reduce((acc, resultNew) => {
      const resultOld = seatsOld.find(
        (resultOld) => resultOld.party === resultNew.party
      );

      let lost = 0,
        gain = 0;
      if (resultOld) {
        const diff = resultNew.seats - resultOld.seats;
        if (diff < 0) lost = -diff; // seats decreased, count as loss
        else if (diff > 0) gain = diff; // seats increased, count as gain
      }

      acc[deigrengCase(resultNew.party)] = {
        lost,
        gain,
      };

      return acc;
    }, {});
  }

  const chartData = rawChartDataCurrent.map((item) => {
    return {
      party: deigrengCase(item.sigles[0].sigle.contenu),
      percentage: parseFloat(item.pourcentage),
      color: colors[formatString(deigrengCase(item.sigles[0].sigle.contenu))],
    };
  });

  return (
    <div className="flex flex-col mt-20">
      <div className="flex flex-row border-2 border-gray-200 border-t-0 border-l-0 border-r-0 pb-2">
        <span className="font-semibold text-32 leading-38 uppercase w-2/4">
          {locales[langId].results}
        </span>
        <div className="pt-3 text-right w-2/4">
          {isDesktop && (
            <span
              className="mr-10 text-xs"
              style={{ color: "rgba(0, 0, 0, 0.6)" }}
            >
              {locales[langId].resultsUpdated +
                " " +
                formatDate(data["2023"].results.dateDerniereModification) +
                " " +
                locales[langId].resultsHour}
            </span>
          )}
        </div>
      </div>
      <hr />
      <div className="flex flex-col wort-medium:flex-row mt-6 justify-between wort-medium:px-4">
        <div className="flex flex-col justify-center mt-3  wort-medium:mr-20 wort-medium:w-1/2">
          <span className="text-22 leading-26 text-left font-bold mb-5">
            {locales[langId].votesPercentageParty}
          </span>
          <div className="h-[280px]">
            <Percentage data={chartData} langId={langId} />
          </div>
        </div>

        <div className="flex flex-col justify-center mt-3 wort-medium:w-1/2">
          <span className="text-22 leading-26 text-left font-bold mb-5">
            {locales[langId].votesDifference}
          </span>

          {!hasSeatsDifference && (
            <span className="text-md leading-26 text-left font-bold mt-20">
              {locales[langId].votesDifferenceMessage}
            </span>
          )}
          <div>
            {hasSeatsDifference && (
              <DifferencePyramid data={seatsDifference} langId={langId} />
            )}
          </div>
        </div>
      </div>
      <div className="flex flex-col mt-10 wort-medium:px-4">
        <span className="text-22 leading-26 text-left font-bold mb-5">
          {locales[langId].coalitionOptions}
        </span>
        <div>
          <CoalitionBuilder data={chartData} langId={langId} />
        </div>
      </div>
    </div>
  );
};

export default React.memo(Result);
